export default __webpack_public_path__ + "static/media/imgloader.9f601208.gif";